/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';

import Bg from 'assets/images/SMSSentDialog.svg';

import PopupHeader from 'clientCommunications/components/Clients/ConfirmationModal/PopupHeader';
import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';

class NoSmsCredit extends React.Component {
  constructor(props) {
    super(props);
    this.state = { openPurchaseModal: false };
  }

  closePurchaseModal = () => void this.setState({ openPurchaseModal: false });
  openPurchaseModal = () => void this.setState({ openPurchaseModal: true });

  render() {
    return (
      <div data-bem="NoSmsCredit" className="dialog-container-marketing">
        {!this.state.openPurchaseModal && (
          <div className="popup-2-button animated zoomIn">
            <PopupHeader
              isModalAction={this.props.isModalAction}
              onClose={() => {}}
              history={this.props.history}
              style={{ background: `Url(${Bg})`, height: '414px', borderRadius: '4px' }}
            >
              <div className="flex-center">
                <div className="modal-content">
                  <div className="sms-title">
                    <div>Sorry, you need two SMS credit to request deposit but you don&apos;t have any left.</div>
                  </div>
                  <p className="uniq-note">Don’t worry, purchasing more credits only takes a minute!</p>
                  <br />
                </div>
              </div>
            </PopupHeader>
            <div className="footer-marketing-sendsms cfix fromMarketing">
              <div className="marketing-button-container">
                <button
                  className="sms-btn-white"
                  onClick={this.props.closeNoSmsCreditModal}
                  style={{ marginRight: '46px' }}
                >
                  NO THANKS
                </button>
                <button className="sms-btn-violet" onClick={this.openPurchaseModal}>
                  GET MORE SMS CREDIT
                </button>
              </div>
            </div>
          </div>
        )}
        {this.state.openPurchaseModal && (
          <PurchaseSmsCreditDialog
            closePopup={this.closePurchaseModal}
            purchaseSmsBundle={this.props.purchaseSmsBundle}
            salonId={this.props.salonId}
            errorMessage={this.props.errorMessage}
            gotoBilling={this.props.gotoBilling}
            isFetching={this.props.isFetching}
            sms_credits_available={this.props.sms_credits_available}
            fromRequestDeposit
            permission={this.props.permission}
            variantButton="normal"
          />
        )}
      </div>
    );
  }
}

export default NoSmsCredit;
